import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

const chip = (on) =>
  `rounded-full border px-3.5 py-1.5 text-sm transition-colors ${on ? "border-primary bg-primary text-primary-foreground" : "border-border hover:bg-accent/40"}`;

export default function ProjectPicker({ projects, notes, value, onChange, onNew }) {
  const count = (id) => notes.filter((n) => (id === "none" ? !n.project : n.project === id)).length;
  return (
    <div className="mt-8 flex flex-wrap items-center gap-2" data-testid="project-picker">
      <button className={chip(value === "all")} onClick={() => onChange("all")} data-testid="project-chip-all">All notes ({notes.length})</button>
      {projects.map((p) => (
        <button key={p.id} className={chip(value === p.id)} onClick={() => onChange(p.id)} data-testid={`project-chip-${p.id}`}>
          {p.name} ({count(p.id)})
        </button>
      ))}
      <button className={chip(value === "none")} onClick={() => onChange("none")} data-testid="project-chip-none">No project ({count("none")})</button>
      <Button variant="outline" size="sm" className="rounded-full" onClick={onNew} data-testid="new-project-button">
        <Plus className="h-4 w-4 mr-1" /> New project
      </Button>
    </div>
  );
}
